import {
  abbreviateId,
  Divider,
  HStack,
  IndicatorBadge,
  type IndicatorBadgeProps,
  InlineFormattedNumber,
  type Quote,
  Text,
  VStack,
} from '@talos/kyoko';
import type { ReactNode } from 'react';

export const RFQSweepingPanelHeader = ({ quote }: { quote: Quote }) => {
  return (
    <HStack background="colors.gray.030" justifyContent="space-between" alignItems="center" p="spacing16">
      {/* Left side */}
      <HStack gap="spacing12">
        <HeaderItem
          label="Correlation ID"
          testid="sweeping-panel-header-correlation-id"
          content={<Text color="colorTextImportant">{abbreviateId(quote.ParentRFQID ?? '-')}</Text>}
        />

        <Divider orientation="vertical" />

        <HeaderItem
          label="Quantity"
          testid="sweeping-panel-header-quantity"
          content={<InlineFormattedNumber number={quote.OrderQty} currency={quote.Currency} />}
        />
      </HStack>

      {/* Right side */}
      <HStack gap="spacing12" />
    </HStack>
  );
};

interface HeaderItemProps {
  label: string;
  content: ReactNode;
  variant?: IndicatorBadgeProps['variant'];
  testid?: string;
}

function HeaderItem({ label, content, variant, testid }: HeaderItemProps) {
  return (
    <VStack gap="spacing4" alignItems="flex-start" data-testid={testid}>
      <IndicatorBadge children={label} variant={variant} />
      {content}
    </VStack>
  );
}
